import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { cleanReducerOnPageChange } from '../utils'

const getInitialState = () => ({
  profilePin: null
})

const initialState = getInitialState() 

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfilePin(state, action) {
        state.profilePin = action.payload
    }
  },
  extraReducers: (builder) => cleanReducerOnPageChange(builder, getInitialState)
})

export const useProfilePin = () => useSelector( state => state.profile.profilePin )
export const { setProfilePin } = profileSlice.actions
export default profileSlice
